<template>
    <painel :titulo="titulo" icone="pi pi-calendar" :refreshFunction="obterEvento" v-show="mostrarEvento">
        <div class="mb-2">
            <TabView v-model:activeIndex="activeIndex">
                <TabPanel header="Dados Gerais">
                    <div class="mb-4" v-if="evento">
                        <Message :closable="false" severity="warn" v-if="evento.nivel == 0 && !evento.configurado && !evento.participantesInternos">
                            <strong>Evento pendente de configurações adicionais</strong>
                        </Message>
                        <detalhe :size="cabecalho" titulo="Evento Pai" v-if="evento.eventoPai"
                            >{{ evento.eventoPai.codigo }} - {{ evento.eventoPai.nome }}</detalhe
                        >
                        <detalhe :size="cabecalho" titulo="Código">{{ evento.codigo }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Nome">{{ evento.nome }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Descrição">{{ evento.descricao }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Código Interno">{{ evento.codigoInterno }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Número Interno">{{ evento.numeroInterno }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Data Inicio">{{ $dateFormat(evento.dataInicio, 'DD/MM/yyyy') }} </detalhe>
                        <detalhe :size="cabecalho" titulo="Data Fim">{{ $dateFormat(evento.dataFim, 'DD/MM/yyyy') }} </detalhe>
                        <detalhe :size="cabecalho" titulo="Responsável"
                            ><span v-if="evento.codResponsavel">({{ evento.codResponsavel }}) </span>{{ evento.responsavel }}</detalhe
                        >
                        <detalhe :size="cabecalho" titulo="Código Externo" v-if="evento.nivel == 0 && !evento.participantesInternos">{{
                            evento.codigoExterno
                        }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Conta" v-if="evento.nivel == 0 && evento.contaEventoId">{{ evento.conta.nome }}</detalhe>
                        <detalhe :size="cabecalho" titulo="Sincronismo" v-if="evento?.nivel == 0 || evento?.participantesInternos">
                            <status :status="evento.statusDescricao"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Gera Atendimento">
                            <status :status="evento.geraAtendimento ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Sincronizar Checkins Externos" v-if="evento?.nivel == 0">
                            <status :status="evento.sincronizarCheckinExterno ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Pesquisar Somente na Base do Evento" v-if="evento?.nivel == 0">
                            <status :status="evento.pesquisarSomenteBaseEvento ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Não Apresentar Formulário de Novo Credenciamento" v-if="evento?.nivel == 0">
                            <status :status="evento.naoExibirFormularioNovoCredenciamento ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Buscar CNPJ" v-if="evento.nivel == 0 || (evento.nivel != 0 && !evento.eventoPai.buscarCnpj)">
                            <status :status="evento.buscarCnpj ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Gratuito" v-if="evento.codigoInterno != '0'">
                            <status :status="evento.eventoGratuito ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                        <detalhe :size="cabecalho" titulo="Obter Participantes do FOCO">
                            <status :status="evento.participantesInternos ? 'SIM' : 'NÃO'"></status>
                        </detalhe>
                    </div>
                </TabPanel>
                <TabPanel header="Eventos" v-if="mostrarAbaEventos">
                    <eventos :evento="evento"></eventos>
                </TabPanel>
                <TabPanel header="Configurações do Evento" v-if="mostrarAbaConfiguracoesDoEvento">
                    <detalhar-evento-configuracao :evento="evento" ref="eventoConfig" @obterEventoAtualizado="obterEvento()"></detalhar-evento-configuracao>
                </TabPanel>
                <TabPanel header="Configurações de Atendimento" v-if="mostrarAbaAtendimentoDetalhe">
                    <detalhar-atendimento-detalhe :evento="evento" :buttonAtendimento="buttonAtendimento"></detalhar-atendimento-detalhe>
                </TabPanel>
                <TabPanel header="Participantes">
                    <participantes :evento="evento" v-if="evento"></participantes>
                </TabPanel>
                <TabPanel header="Checkins">
                    <checkins :evento="evento" v-if="evento"> </checkins>
                </TabPanel>
                <TabPanel header="Atendimento" v-if="mostrarAbaAtendimentoDetalhe">
                    <Atendimento :evento="evento" v-if="evento"> </Atendimento>
                </TabPanel>
                <TabPanel header="Dashboard">
                    <dashboard :evento="evento" v-if="evento"></dashboard>
                </TabPanel>
                <TabPanel header="Credenciamento">
                    <credenciamento :evento="evento" v-if="evento" @atualizar="obterEvento()"></credenciamento>
                </TabPanel>
                <TabPanel header="Agenda">
                    <Agenda :evento="evento" v-if="evento"></Agenda>
                </TabPanel>
            </TabView>
        </div>
        <btn-voltar :route="{ name: 'Checkins_Eventos' }" v-if="evento?.nivel == 0"></btn-voltar>
        <btn-voltar :route="{ name: 'Checkins_Eventos_Detalhar', params: { id: evento.eventoPaiId } }" v-if="evento?.nivel > 0"></btn-voltar>

        <btn-ativar-desativar
            :evento="evento"
            @atualizar="handleEventoUpdate"
            v-if="evento?.nivel == 0 && activeIndex == 0 && evento?.status != 2"
        ></btn-ativar-desativar>

        <btn-atualizar v-if="activeIndex == 0 && evento?.status != 2" :evento="evento"></btn-atualizar>
        <btn-atualizar-atendimento-detalhe :evento="evento" v-if="mostrarBtnAtualizarAtendimento"></btn-atualizar-atendimento-detalhe>
        <btn-gerar-qr-code :evento="evento" v-if="activeIndex == 0"></btn-gerar-qr-code>

        <Button
            label="Atualizar"
            icon="pi pi-pencil"
            class="ml-2"
            @click="eventoConfig?.atualizar()"
            v-if="mostarBotaoAtualizar"
            :disabled="!eventoConfig?.formularioOk"
        />
        <div class="ml-2" v-if="activeIndex == 0" style="display: inline-flex; flex-direction: column; gap: 6px; vertical-align: top">
            <div>
                <span class="mr-2">Etiqueta (mm) — deixe vazio p/ padrão:</span>
                <InputText v-model="alturaEtiqueta" placeholder="Altura" style="width: 6rem" class="mr-2" />
                <InputText v-model="larguraEtiqueta" placeholder="Largura" style="width: 6rem" />
            </div>
            <div>
                <Button label="Credenciamento Touchscreen" icon="pi pi-desktop" class="mr-2" @click="toCredenciamento('touchscreen')" />
                <Button label="Credenciamento Teclado" icon="pi pi-user" @click="toCredenciamento('teclado')" />
            </div>
        </div>

        <Button
            label="Trazer Conf Atendimento"
            class="ml-2"
            v-model="buttonAtendimento"
            @click="acionarButton()"
            v-if="mostrarBtnAtualizarAtendimento && evento?.eventoPai"
        ></Button>

        <BtnPersonalizarLandingPage :evento="evento" v-if="evento != null && activeIndex == 0" />
    </painel>
    <router-view :evento="evento"></router-view>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

import BtnAtivarDesativar from './BtnAtivarDesativar';
import Eventos from './Eventos';
import Atendimento from './Atendimento.vue';
import Participantes from '../participantes/Participantes';
import Checkins from '../checkins/Checkins';
import Agenda from './Agenda.vue';
import BtnAtualizar from './BtnAtualizar';
import EventosServices from './services';
import DetalharAtendimentoDetalhe from './DetalharAtendimentoDetalhe';
import DetalharEventoConfiguracao from './DetalharEventoConfiguracao';
import BtnAtualizarAtendimentoDetalhe from './BtnAtualizarAtendimentoDetalhe';
import Dashboard from './Dashboard';
import BtnGerarQrCode from './BtnGerarQrCode.vue';
import Credenciamento from './Credenciamento.vue';
import BtnPersonalizarLandingPage from './BtnPersonalizarLandingPage';

const store = useStore();
const route = useRoute();
const router = useRouter();

const evento = ref(null);
const buttonAtendimento = ref(false);
const cabecalho = ref('185');
const activeIndex = ref(0);

const eventoConfig = ref(null);

const obterEvento = () => {
    store.dispatch('addRequest');
    EventosServices.obterPorId(route.params.id)
        .then((response) => {
            if (response?.success) {
                evento.value = response.data;
                processarView();
            } else {
                evento.value = null;
            }
        })
        .finally(() => {
            store.dispatch('removeRequest');
        });
};

const acionarButton = () => {
    buttonAtendimento.value = true;
};

const handleEventoUpdate = (novoEvento) => {
    evento.value = novoEvento;
};

const processarView = () => {
    if (route.query.view == 'eventos') {
        activeIndex.value = 1;
    }
    if (route.query.view == 'participantes') {
        if (evento.value.nivel == 0 && evento.value.geraAtendimento && evento.value.conta) {
            activeIndex.value = 4;
        } else if (evento.value.nivel == 0 && !evento.value.geraAtendimento && !evento.value.conta) {
            activeIndex.value = 3;
        } else if ((evento.value.nivel == 0 && !evento.value.geraAtendimento) || (evento.value.nivel != 0 && evento.value.geraAtendimento)) {
            activeIndex.value = 3;
        } else if (!evento.value.nivel == 0 && !evento.value.geraAtendimento) {
            activeIndex.value = 2;
        }
    }
    if (route.query.view == 'atendimento-detalhe') {
        if (evento.value.nivel == 0 && evento.value.conta) {
            activeIndex.value = 3;
        } else if (evento.value.nivel == 0 && !evento.value.conta) {
            activeIndex.value = 2;
        } else {
            activeIndex.value = 1;
        }
    }
};

const alturaEtiqueta = ref('');
const larguraEtiqueta = ref('');

const toCredenciamento = (modo) => {
    const query = {
        evento: evento.value.eventoId,
        modo: modo,
    };
    // Só manda os parâmetros de tamanho quando o usuário preencher.
    if (alturaEtiqueta.value) query.alturaEtiqueta = alturaEtiqueta.value;
    if (larguraEtiqueta.value) query.larguraEtiqueta = larguraEtiqueta.value;
    let routeData = router.resolve({
        name: 'Checkins_Credenciamento',
        query: query,
    });
    window.open(routeData.href, '_blank');
};

const titulo = computed(() => {
    if (evento.value) {
        return `Evento - ${evento.value?.codigo} - ${evento.value?.nome}`;
    }
    return 'Evento';
});

const mostrarEvento = computed(() => route.name == 'Checkins_Eventos_Detalhar');

const mostrarAbaEventos = computed(() => {
    if (evento.value) {
        return evento.value.nivel == 0;
    }
    return true;
});

const mostrarAbaConfiguracoesDoEvento = computed(() => {
    if (evento.value) {
        return evento.value.nivel == 0 && evento.value.conta && evento.value.conta.tipo != 2;
    }
    return true;
});

const mostrarAbaAtendimentoDetalhe = computed(() => {
    return evento.value ? evento.value.geraAtendimento : false;
});

const mostrarBtnAtualizarAtendimento = computed(() => {
    if (evento.value) {
        return (
            evento.value?.geraAtendimento &&
            ((evento.value?.nivel == 0 && !evento.value.conta && activeIndex.value == 2) ||
                (evento.value?.nivel == 0 && evento.value.conta && activeIndex.value == 3) ||
                (evento.value?.nivel != 0 && activeIndex.value == 1))
        );
    }
    return false;
});

const mostarBotaoAtualizar = computed(() => {
    return evento.value?.nivel == 0 && activeIndex.value == 2 && evento.value.conta && evento.value.conta.tipo != 2;
});

onMounted(() => {
    obterEvento();
});

watch(
    () => route.params.id,
    (newId) => {
        if (newId) {
            obterEvento();
            activeIndex.value = 0;
        }
    }
);
</script>
